var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyst1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 334,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 193,
    width: 338,
    height: 334
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 277,
    width: 166,
    height: 165
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-471 -193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.018 363.46C839.223 463.372 755.314 526.408 654.139 526.408 552.964 526.408 471 453.455 471 363.46 471 273.464 552.572 193 653.72 193 754.868 193 791.52 235.097 798.018 363.46",
    fill: "#EBF2FC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.645 339.179 681.432 352.862 712.22 339.179 712.22 304.971 681.432 291.288 650.645 304.971 650.645 339.179ZM602.753 325.496C587.64 325.496 575.387 337.749 575.387 352.862 575.387 367.976 587.64 380.229 602.753 380.229 617.866 380.229 630.12 367.976 630.12 352.862 630.12 337.749 617.866 325.496 602.753 325.496ZM561.703 434.962 561.703 421.279C561.703 393.912 578.807 380.229 602.753 380.229 626.699 380.229 643.803 393.912 643.803 421.279L643.803 434.962 561.703 434.962ZM650.645 304.971 681.432 318.654 712.22 304.971M681.432 318.654 681.432 352.862 681.432 318.654Z",
    stroke: "#1930AB",
    strokeWidth: 13.68,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyst1);
export default __webpack_public_path__ + "static/media/analyst1.a3a5a81ccfc999fab8eb088a3679f185.svg";
export { ForwardRef as ReactComponent };